import axios from "axios";
const instance = axios.create({
  timeout: 10000,
  headers: { Accept: "application/json" }
});

export const getAllModulesList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/module"
  });
  return response;
};

export const getModulesCard = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/card`
  });
  return response;
};

export const addNewModuleInformation = () => {
  const response = instance({
    method: "post",
    url: `/work/api/module/`
  });
  return response;
};

export const getModuleInformation = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}`
  });
  return response;
};

export const updateModuleInformation = (id, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${id}`,
    data
  });
  return response;
};

export const deleteModule = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${id}`
  });
  return response;
};

export const getEducationForm = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/education-form`
  });
  return response;
};

export const getTrialForm = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/trial-form`
  });
  return response;
};

export const getModulePurpose = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/purpose`
  });
  return response;
};

export const getModuleResultSkill = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/result-skill`
  });
  return response;
};

export const getModuleDigitalUsage = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/digital-usage`
  });
  return response;
};

export const getModuleAbility = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/ability`
  });
  return response;
};

export const addModuleAbility = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/ability`,
    data
  });
  return response;
};

export const updateModuleAbility = (idModule, idAbility, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/ability/${idAbility}`,
    data
  });
  return response;
};

export const deleteModuleAbility = (idModule, idAbility) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/ability/${idAbility}`
  });
  return response;
};

export const addModuleCardLogo = (id, images) => {
  const data = new FormData();
  data.set("file", images);

  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/logo`,

    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  });
  return response;
};

export const deleteModuleCardLogo = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${id}/logo`
  });
  return response;
};

export const addModuleProgram = (id, program) => {
  const data = new FormData();
  data.set("file", program);

  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/program`,

    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  });
  return response;
};

export const deleteModuleProgram = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${id}/program`
  });
  return response;
};

export const getAllModuleVolume = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/volume`
  });
  return response;
};

export const addModuleVolume = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/volume`,
    data
  });
  return response;
};

export const updateModuleVolume = (moduleId, volumeId, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${moduleId}/volume/${volumeId}`,
    data
  });
  return response;
};

export const deleteModuleVolume = (moduleId, volumeId) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${moduleId}/volume/${volumeId}`
  });
  return response;
};

export const getAllModuleThemeVolume = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/theme?scope=volume`
  });
  return response;
};

export const getAllModuleAbilityTheme = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/ability?scope=theme`
  });
  return response;
};

export const addModuleThemeVolume = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/theme`,
    data
  });
  return response;
};

export const updateModuleThemeVolume = (moduleId, themeId, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${moduleId}/theme/${themeId}`,
    data
  });
  return response;
};

export const deleteModuleThemeVolume = (moduleId, themeId) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${moduleId}/theme/${themeId}`
  });
  return response;
};

export const getAllModuleLesson = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/lesson`
  });
  return response;
};

export const getAllModuleLessonTheme = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/lesson?scope=theme`
  });
  return response;
};

export const addModuleLesson = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/lesson`,
    data
  });
  return response;
};

export const updateModuleLesson = (idModule, idLesson, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/lesson/${idLesson}`,
    data
  });
  return response;
};

export const deleteModuleLesson = (idModule, idLesson) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/lesson/${idLesson}`
  });
  return response;
};

export const getAllLessonType = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/program-lesson-type`
  });
  return response;
};

export const getResourceList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/site`
  });
  return response;
};

export const getLessonResourceList = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/site?scope=lesson`
  });
  return response;
};

export const getAllRoomTypesList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/room-type`
  });
  return response;
};

export const getAllModuleRoomList = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/room?scope=lesson`
  });
  return response;
};

export const addModuleRoomList = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/room`,
    data
  });
  return response;
};

export const updateModuleRoomList = (idModule, idRoom, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/room/${idRoom}`,
    data
  });
  return response;
};

export const deleteModuleRoomList = (idModule, idRoom) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/room/${idRoom}`
  });
  return response;
};

export const getAllResourceTypeList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/resource-type`
  });
  return response;
};

export const getAllModuleResourceList = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/resource?scope=lesson`
  });
  return response;
};

export const addModuleResource = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/resource`,
    data
  });
  return response;
};

export const updateModuleResource = (idModule, idResource, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/resource/${idResource}`,
    data
  });
  return response;
};

export const deleteModuleResource = (idModule, idResource) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/resource/${idResource}`
  });
  return response;
};

export const getAllModuleReference = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/reference`
  });
  return response;
};

export const addModuleReference = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/reference`,
    data
  });
  return response;
};

export const updateModuleReference = (idModule, idReference, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/reference/${idReference}`,
    data
  });
  return response;
};

export const deleteModuleReference = (idModule, idReference) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/reference/${idReference}`
  });
  return response;
};

export const getAllModuleSite = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/site`
  });
  return response;
};

export const addModuleSite = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/site`,
    data
  });
  return response;
};

export const updateModuleSite = (idModule, idSite, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/site/${idSite}`,
    data
  });
  return response;
};

export const deleteModuleSite = (idModule, idSite) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/site/${idSite}`
  });
  return response;
};

export const getModuleSchedule = idModule => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${idModule}/schedule`
  });
  return response;
};

export const getModuleEstimate = idModule => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${idModule}/estimate`
  });
  return response;
};

export const getAllModuleCriterion = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/criterion`
  });
  return response;
};

export const addModuleCriterion = (id, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/module/${id}/criterion`,
    data
  });
  return response;
};

export const updateModuleCriterion = (idModule, idCriterion, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/module/${idModule}/criterion/${idCriterion}`,
    data
  });
  return response;
};

export const deleteModuleCriterion = (idModule, idCriterion) => {
  const response = instance({
    method: "delete",
    url: `/work/api/module/${idModule}/criterion/${idCriterion}`
  });
  return response;
};

export const getAllModuleCompilers = id => {
  const response = instance({
    method: "get",
    url: `/work/api/module/${id}/authoring`
  });
  return response;
};

export const compilers = data => {
  const response = instance({
    method: "post",
    url: `/work/api/module/rpc`,
    data
  });
  return response;
};

export const getOrganizationStaff = id => {
  const response = instance({
    method: "get",
    url: `/work/api/organization/${id}/staff/`
  });
  return response;
};
